export const channels = [
  {
    id: "online",
    icon: "ri-send-plane-line",
    title: "在线投稿入口",
    tag: "最常用",
    desc: "直接在页面填写线索表单，支持匿名提交。写下你掌握的时间、地点与经过，编辑团队会在后台收到加密报送。",
    action: "填写在线投稿表单",
    href: "#submit",
  },
  {
    id: "dm",
    icon: "ri-chat-private-line",
    title: "私信投稿",
    tag: "可对话",
    desc: "通过邮箱私信直接联系编辑，适合需要来回确认细节的线索。你可以只留一个临时邮箱，事后再决定是否继续沟通。",
    action: "获取私信方式",
    href: "#contact",
  },
  {
    id: "clue",
    icon: "ri-search-eye-line",
    title: "线索征集",
    tag: "长期有效",
    desc: "围绕消费维权、行业乱象、用工环境等议题，编辑部长期征集线索。哪怕只是一个细节，也可能补上关键一环。",
    action: "查看征集议题",
    href: "#categories",
  },
];